export default {
    groupName: 'comcast-smb-premarket',
    appName: 'Comcast Business Pre Test Dashboards',
    baseRoute: '/dashboard/comcast-smb-premarket',
    label: 'Copy Test Dashboard',
    home: '/slicer',
    image: 'dummy-2.png',
    description: 'Comcast Business Copy Test Dashboard'
}
